import React from 'react';
import { Box, Typography } from "@material-ui/core";
import { theme } from "@app/helpers";

interface IProps {
    children?: React.ReactNode
    title?: string;
}

export const PasslyOutlinedBox = (props: IProps) => {
    const { title } = props;

    return (
        <Box border={1} borderRadius={4} borderColor={theme.palette.grey[300]}>
            {title !== undefined && title !== '' &&
                <Box width={'100%'} pl={2} pt={.5} pb={.5} style={{ backgroundColor: theme.palette.grey[200] }}>
                    <Typography variant="h6">{title}</Typography>
                </Box>
            }
            <Box p={2}>
                {props.children}
            </Box>
        </Box>
    )
}